import React, {Component} from 'react';
import PropTypes from 'prop-types';

import {StringLengthRule as DXStringLengthRule} from 'devextreme-react/validator';


export default class ValidatorStringLengthRule extends Component {
    render() {
        return <DXStringLengthRule {...this.props}/>
    }
}

ValidatorStringLengthRule.propTypes = {
    /**
     * If set to true, empty values are valid
     */
    ignoreEmptyValue: PropTypes.bool,
    /**
     * Specifies the maximum length allowed for the validated value
     */
    max: PropTypes.number,
    /**
     * Specifies the message that is shown if the rule is broken
     */
    message: PropTypes.string,
    /**
     * Specifies the minimum length allowed for the validated value
     */
    min: PropTypes.number,
    /**
     * Indicates whether or not to remove the Space characters from the validated value
     */
    trim: PropTypes.bool,
    /**
     * Specifies the rule type. Set it to "stringLength" to use the StringLengthRule
     */
    type: PropTypes.oneOf(['required', 'numeric', 'range', 'stringLength', 'custom', 'compare', 'pattern', 'email', 'async']),
};

ValidatorStringLengthRule.defaultProps = {
    ignoreEmptyValue: false,
    // max: undefined,
    message: 'The length of the value is not correct',
    // min: undefined,
    trim: true,
    type: 'stringLength',
};
